import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Popover from '@material-ui/core/Popover'
import Avatar from 'ui/components/avatar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconClose } from 'assets/icons/close.svg'
import { ReactComponent as IconLogOut } from 'assets/icons/log-out.svg'
import useStyles from './styles'
import useTranslation from 'hooks/useTranslations'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const UserPopover = props => {
  const {
    id,
    open,
    onClose,
    anchorEl,
    anchorOrigin,
    transformOrigin,
    avatarName,
    user,
    email,
    onLogOut,
  } = props

  const t = useTranslation()

  const classes = useStyles()

  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      elevation={3}
      className={clsx(isSmall && classes.popoverXS)}
    >
      <div className={classes.wrapperContent}>
        <div className={classes.header}>
          <Avatar size="medium" className={classes.avatar}>
            {avatarName}
          </Avatar>
          <div className={classes.userInfo}>
            <Typography variant="h2">{user}</Typography>
            <Typography variant="body2" className={classes.email}>
              {email}
            </Typography>
          </div>
          <IconButton
            aria-label="close"
            onClick={onClose}
            className={classes.closeButton}
          >
            <SvgIcon
              component={IconClose}
              className={classes.closeButtonIcon}
            />
          </IconButton>
        </div>

        <Button className={classes.buttonLogout} onClick={onLogOut}>
          <SvgIcon
            component={IconLogOut}
            className={classes.iconButtonLogout}
          />
          <Typography variant="body2" className={classes.textButtonLogout}>
            {t('logout:title')}
          </Typography>
        </Button>
      </div>
    </Popover>
  )
}

UserPopover.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  anchorEl: PropTypes.object,
  anchorOrigin: PropTypes.object,
  transformOrigin: PropTypes.object,
  avatarName: PropTypes.string,
  user: PropTypes.string,
  email: PropTypes.string,
  onLogOut: PropTypes.func,
}

export default UserPopover
